import React from "react";

/**
 * The club's badges a child has not been given yet. Renders nothing when
 * there are none, so a child who has every badge sees no empty section.
 */
const LockedBadges = ({ badges = [] }) => {
  if (badges.length === 0) return null;

  return (
    <>
      <h2 className="text-fluid-xl font-medium font-manrope  text-[#0F2D50] mb-1">
        Locked Badges
      </h2>
      <p className="text-black opacity-70  font-manrope text-fluid-md mt-2 mb-6">
        Keep working to unlock these achievements
      </p>
      <div className="flex flex-wrap gap-4 max-sm:grid-cols-2 max-sm:grid pb-12">
        {badges.map((badge) => (
          <div
            key={badge.id || badge.name}
            className="w-48 h-48 max-sm:w-full max-sm:h-48 relative p-3 bg-white/40 rounded-[20px]"
          >
            {/* Lock Icon Container */}
            <div className="w-14 h-14 px-3 pt-3 left-1/2 -translate-x-1/2 top-[25px] absolute bg-white rounded-full shadow-[0px_4px_6px_-4px_rgba(0,0,0,0.10)] inline-flex flex-col justify-start items-start">
              <div className="self-stretch h-8 relative overflow-hidden flex items-center justify-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M17 8h-1V6a4 4 0 00-8 0v2H7a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V10a2 2 0 00-2-2zM9 6a3 3 0 016 0v2H9V6zm8 14H7V10h10v10z"
                    fill="#6B7280"
                  />
                </svg>
              </div>
            </div>

            {/* Title */}
            <div className="w-40 left-1/2 -translate-x-1/2 top-[100px] absolute">
              <p className="text-center text-zinc-900 text-base font-semibold font-manrope leading-6">
                {badge.name}
              </p>
            </div>

            {/* Description */}
            {badge.description && (
              <div className="w-32 left-1/2 -translate-x-1/2 top-[137px] absolute">
                <p className="text-center text-slate-900 text-xs font-medium font-manrope leading-4 line-clamp-3">
                  {badge.description}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default LockedBadges;
